var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * Detail screen component for viewing/editing entity details.
 * Displays a form-like layout with labeled fields centered in a single column.
 *
 * ## Usage
 * ```html
 * <kr-screen-detail title="Company Details">
 *   <kr-button slot="actions">Save</kr-button>
 *   <kr-text-field label="Company Name" value="Acme Corporation"></kr-text-field>
 *   <kr-text-field label="Industry" value="Technology"></kr-text-field>
 *   <kr-text-field label="Website" value="https://acme.com"></kr-text-field>
 * </kr-screen-detail>
 * ```
 *
 * @slot - Form fields and content (centered, max-width 480px)
 * @slot actions - Action buttons displayed in the header on the right
 *
 * @property {string} title - Section title (e.g., "Company Details")
 */
export class KRScreenDetail extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Section title
         */
        this.title = '';
    }
    render() {
        return html `
      <div class="header">
        <h2 class="header__title">${this.title}</h2>
        <div class="header__actions">
          <slot name="actions"></slot>
        </div>
      </div>
      <div class="content">
        <div class="content__inner">
          <slot></slot>
        </div>
      </div>
    `;
    }
}
KRScreenDetail.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
    }

    .header {
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      background: #ffffff;
      border-bottom: 1px solid #e5e7eb;
      flex-shrink: 0;
    }

    .header__title {
      font-size: 18px;
      font-weight: 600;
      color: #111827;
      margin: 0;
    }

    .header__actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .content {
      flex: 1;
      overflow-y: auto;
      padding: 24px;
      display: flex;
      justify-content: center;
    }

    .content__inner {
      width: 100%;
      max-width: 700px;
    }
  `;
__decorate([
    property({ type: String })
], KRScreenDetail.prototype, "title", void 0);
// Guarded registration: no-op if the tag is already defined, so a second copy of krubble on
// the page (e.g. the Operations shell loads krubble globally while an embedded app bundled its
// own copy) doesn't throw. First definition wins.
if (!customElements.get('kr-screen-detail')) {
    customElements.define('kr-screen-detail', KRScreenDetail);
}
//# sourceMappingURL=screen-detail.js.map